export default "Estimez vos primes CEE agricoles (séchoirs, photovoltaïque, isolation) avec votre SIRET. Résultat chiffré adapté aux fiches AGRI en 60 secondes.";

